import {
  SendTargetType,
  SendTo,
  TeamDisplayData,
  TenantMemberAndTeamDisplayData,
  TenantMemberDisplayData,
} from '@kudos/http-client'
import { fullNameFromParts } from './nameFormatting'

export const getSendToFromTenantMemberAndTeams = (
  recipients: TenantMemberAndTeamDisplayData[],
): SendTo[] => {
  return recipients.map(recipient => {
    const isTeam = 'teamType' in recipient
    const fullName =
      !isTeam &&
      fullNameFromParts(
        (recipient as TenantMemberDisplayData).firstName,
        (recipient as TenantMemberDisplayData).lastName,
      )
    return {
      id: recipient.id,
      name: isTeam ? (recipient as TeamDisplayData).name : fullName,
      type: isTeam ? SendTargetType.TEAM : SendTargetType.TENANT_MEMBER,
    } as SendTo
  })
}
